import React from 'react'
import { formatCurrency } from '../../../lib/utils/formatNumber'
import { Vehicle } from '../../../lib/types/Vehicle'
import { ImageGallery } from '@demandlocal/components'
import FallbackImage from './../../../images/fallback_car.png'
import cleanUrl from '../../../lib/utils/cleanURL'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const GridItemSoldVehicle = ({
  item,
}: {
  item: Vehicle & { sale_date: Date; buyer_name: string }
}): JSX.Element => {
  const images = (item?.image_url?.match(/https:\/\/.*?(?=\|\|\|\||\|https|,https|;https|$)/) || []).map(cleanUrl)
  return (
    <div className={'rounded-lg overflow-hidden'}>
      <div className={'h-[220px] '}>
        <ImageGallery
          fallbackImage={FallbackImage}
          key={item?.vin_number}
          images={images}
        />
      </div>
      <div className={'flex flex-col gap-3 bg-cultured-gray text-primary-xiketic p-5'}>
        <span className={'text-base font-bold '}>
          {item.year ?? ''} {item.make ?? ''} {item?.model ?? ''}
        </span>
        <div className={'flex flex-col font-medium text-xs gap-1 '}>
          <span>VIN: {item?.vin_number}</span>
          <span>Buyer: {item?.buyer_name}</span>
          <span>Days on Lot Before Sale: {item?.days_on_lot || 'N/A'}</span>
          <span>Sale Date: {dayjs(item?.sale_date).format('MMM D, YYYY') || 'N/A'}</span>
        </div>
        <div>
          <span className={'text-base font-bold'}>
            Sale Price: {formatCurrency(Number(item?.price) || 0)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default GridItemSoldVehicle
